var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiabetes2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2423_489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 8,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.377 1.76172H3.70703V22.3317H10.377V1.76172Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2423_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3069 2.51172L5.57691 11.4717C3.92691 14.7117 3.7269 18.8617 7.6369 20.9517C7.6369 20.9517 9.45691 21.9117 11.4269 21.4517",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2423_489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 8,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0567 1.76172H10.3867V22.3317H17.0567V1.76172Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2423_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4667 2.51172L15.1967 11.4717C16.8467 14.7117 17.0467 18.8617 13.1367 20.9517C13.1367 20.9517 11.3167 21.9117 9.34668 21.4517",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2423_489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 1,
    width: 4,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0768 1.76172H15.2568V9.92171H18.0768V1.76172Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2423_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.047 2.51172L16.397 5.64172C15.817 6.77172 15.747 8.22171 17.117 8.95171C17.117 8.95171 17.747 9.28171 18.437 9.13171",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2423_489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 1,
    width: 3,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8971 1.76172H18.0771V9.92171H20.8971V1.76172Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2423_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1068 2.51172L19.7568 5.64172C20.3368 6.77172 20.4068 8.22171 19.0368 8.95171C19.0368 8.95171 18.4068 9.28171 17.7168 9.13171",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56738 17.0713H12.2274C12.4874 17.0713 12.6974 17.1213 12.8374 17.2313C12.9774 17.3413 13.0474 17.4813 13.0474 17.6513C13.0474 17.8113 12.9874 17.9412 12.8774 18.0612C12.7674 18.1812 12.5974 18.2313 12.3774 18.2313H8.62738C8.37738 18.2313 8.17738 18.1613 8.02738 18.0312C7.87738 17.9012 7.81738 17.7413 7.81738 17.5513C7.81738 17.4313 7.86738 17.2813 7.95738 17.0813C8.04738 16.8913 8.14739 16.7313 8.25739 16.6213C8.70739 16.1713 9.11738 15.7913 9.47738 15.4713C9.83738 15.1513 10.0974 14.9412 10.2574 14.8412C10.5374 14.6512 10.7674 14.4612 10.9474 14.2712C11.1274 14.0812 11.2774 13.8813 11.3674 13.6813C11.4574 13.4813 11.5174 13.2812 11.5174 13.0912C11.5174 12.8812 11.4674 12.7012 11.3574 12.5312C11.2474 12.3613 11.1174 12.2413 10.9374 12.1513C10.7574 12.0613 10.5674 12.0113 10.3574 12.0113C9.91738 12.0113 9.56738 12.2013 9.30738 12.5713C9.27738 12.6213 9.21738 12.7513 9.13738 12.9713C9.05738 13.1913 8.96738 13.3613 8.86738 13.4713C8.76738 13.5813 8.61738 13.6513 8.42738 13.6513C8.25738 13.6513 8.11739 13.6012 8.00739 13.4912C7.89739 13.3812 7.83738 13.2413 7.83738 13.0513C7.83738 12.8313 7.88738 12.5912 7.99738 12.3512C8.09738 12.1112 8.25738 11.8813 8.46738 11.6913C8.67738 11.4913 8.93739 11.3313 9.25739 11.2113C9.57739 11.0913 9.95738 11.0312 10.3874 11.0312C10.9074 11.0312 11.3474 11.1113 11.7174 11.2613C11.9574 11.3613 12.1674 11.5113 12.3474 11.6913C12.5274 11.8713 12.6674 12.0813 12.7674 12.3213C12.8674 12.5613 12.9174 12.8112 12.9174 13.0612C12.9174 13.4612 12.8174 13.8312 12.6074 14.1612C12.3974 14.4912 12.1874 14.7513 11.9674 14.9413C11.7474 15.1313 11.3874 15.4213 10.8774 15.8213C10.3674 16.2213 10.0174 16.5313 9.82738 16.7513C9.74738 16.8413 9.66738 16.9413 9.57738 17.0713H9.56738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes2);
export default __webpack_public_path__ + "static/media/Diabetes-2.057d41ff5d43a4c254223cf6be3dc9db.svg";
export { ForwardRef as ReactComponent };